import React from "react";
import SingleInstrumentSection from "./SingleInstrumentSection";
import InstrumentSelector from "./InstrumentSelector";

function InstrumentServiceSection(props) {

    return (
        <div className="mb-3">
            <label className="form-label">Prístroje</label>
            {props.data.Pristroje
                .map((item, originalIndex) => ({ item, originalIndex }))  // Attach the original index to each item
                .filter(({ item }) => item.CP_verzia === props.cpVersion)  // Filter by CP_verzia
                .map(({ item, originalIndex }) => (
                <SingleInstrumentSection  selectPart={props.selectPart} deletePart={props.deletePart} updatePart={props.updatePart}
                                          selectWork={props.selectWork} deleteWork={props.deleteWork} updateWork={props.updateWork}
                                          deleteInstrument={props.deleteInstrument} selectInstrument={props.selectInstrument}
                                          data={props.data} update={props.update} ndx={originalIndex} item={item} emptyInstrument={false}
                                          key={originalIndex}/>
            ))}
            <InstrumentSelector value=""
                                selectInstrument={props.selectInstrument}
                                optionDisplay="SNR"
                                ndx={props.ndx}
                                index={null}
                                stateResetOnChange={true}
                                data={props.data}
                                cpVersion={props.cpVersion}
                                empty={true}
            />
        </div>
    )
}

export default InstrumentServiceSection
